import { createPortal } from "react-dom";

type CustomChatCardProps = {
  icon: string;
  title: string;
  href: string;
};

const CustomChatCard = ({ icon, title, href }: CustomChatCardProps) => {
  return createPortal(
    <a
      className="flex shadow-lg w-72 rounded-t-2xl items-center space-x-3 px-5 p-3 bg-slate-800 hover:bg-slate-900 transition-all duration-300 cursor-pointer fixed bottom-0 right-5"
      href={href}
      target="_blank"
    >
      <div className="w-7 h-7 rounded-full bg-gray-300 flex items-center justify-center">
        <img src={icon} alt={title} />
      </div>
      <span className="text-sm font-semibold text-white">{title}</span>
    </a>,
    document.getElementById("chat-card-root")!
  );
};

export default CustomChatCard;
